export default __webpack_public_path__ + "static/media/cg_birds_view.1fae3a4e.jpg";